/* eslint-disable import/prefer-default-export */
export { default as Api } from './api';

export const GAME_LIST = [
    {
        id: 'capybara',
        cardType: 'game',
        title: 'game.content1.game14.title',
        desc: 'game.content1.game14.desc',
        buttonText: 'game.content1.game14.buttonText',
        mobileImg: require('@/assets/img/game/game_cover_capy@768.png'),
        mobileIcon: require('@/assets/img/game-detail/game-capybara/game_icon_capybara.png'),
        pcImg: require('@/assets/img/game/game_cover_capy.png'),
        pcIcon: require('@/assets/img/game-detail/game-capybara/game_icon_capybara.png'),
        isShow: true
    },
    {
        id: 'archero2',
        cardType: 'game',
        title: 'game.content1.game15.title',
        desc: 'game.content1.game15.desc',
        buttonText: 'game.content1.game15.buttonText',
        mobileImg: require('@/assets/img/game/game_cover_archero2@768.png'),
        mobileIcon: require('@/assets/img/game-detail/game-archero2/game_icon_archero2.png'),
        pcImg: require('@/assets/img/game/game_cover_archero2.png'),
        pcIcon: require('@/assets/img/game-detail/game-archero2/game_icon_archero2.png'),
        isShow: true
    },
    {
        id: 'survivor',
        cardType: 'game',
        title: 'game.content1.game8.title',
        desc: 'game.content1.game8.desc',
        buttonText: 'game.content1.game8.buttonText',
        mobileImg: require('@/assets/img/game/Survivor@768.png'),
        mobileIcon: require('@/assets/img/game-detail/game-survivor/icon.png'),
        pcImg: require('@/assets/img/game/Survivor.png'),
        pcIcon: require('@/assets/img/game-detail/game-survivor/icon.png'),
        isShow: true
    },
    {
        id: 'archero',
        cardType: 'game',
        title: 'game.content1.game1.title',
        desc: 'game.content1.game1.desc',
        buttonText: 'game.content1.game1.buttonText',
        mobileImg: require('@/assets/img/game/game_cover_archero@768.png'),
        mobileIcon: require('@/assets/img/game-detail/game-archero/archero-icon@2x.png'),
        pcImg: require('@/assets/img/game/game_cover_archero.png'),
        pcIcon: require('@/assets/img/game-detail/game-archero/archero-icon@2x.png'),
        isShow: true
    },
    {
        id: 'punball',
        cardType: 'game',
        title: 'game.content1.game3.title',
        desc: 'game.content1.game3.desc',
        buttonText: 'game.content1.game3.buttonText',
        mobileImg: require('@/assets/img/game/game_cover_punball@768.png'),
        mobileIcon: require('@/assets/img/game-detail/game-punball/icon@2x.png'),
        pcImg: require('@/assets/img/game/game_cover_punball.png'),
        pcIcon: require('@/assets/img/game-detail/game-punball/icon@2x.png'),
        isShow: true
    },
    {
        id: 'comingsoon',
        cardType: 'comingsoon',
        title: 'game.content1.game12.title',
        isShow: true
    }
];
